const c = ["#c9562c", "#f6edbc", "#007f80"], E = ["#ca562c", "#e6a473", "#f6edbc", "#92b69e", "#007f80"], G = [
  "#ca562c",
  "#de8a5a",
  "#edbb8a",
  "#f6edbd",
  "#b4c8a8",
  "#70a494",
  "#007f80"
];
export {
  c as DIVERGING_RED_GREEN_3,
  E as DIVERGING_RED_GREEN_5,
  G as DIVERGING_RED_GREEN_7
};
//# sourceMappingURL=index.es5589.js.map
